<template>
    <v-text-field 
        :value="value"
        @change="$emit('change', $event)"
        :label="schema.label" 
        :hide-details="false" 
        :hint="schema.hint" 
        :placeholder="schema.placeholder || ' '"
        outlined dense
        prefix="$"
    />
</template>

<script>



export default {

    data() {
        return { 

        }
    },

    components: {
        
    },
    
    props: {
        value: String,
        schema: Object,
    },

    computed: {
  
    },

    methods: {


    },

    created() {

    },

    watch: {

    }

}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// CurrencyControl.vue?64022d02